import React from 'react';
import { useAppSelector } from '../../../store';
import { LoadingSpinner } from './LoadingSpinner';

interface DataInitializerProps {
  children: React.ReactNode;
}

/**
 * DataInitializer Component
 * 
 * Shows a loading spinner while database data is being fetched.
 * Does not automatically fetch data - data fetching is triggered by user actions.
 */
export const DataInitializer: React.FC<DataInitializerProps> = ({ children }) => {
  const { loading } = useAppSelector((state) => state.database);
  
  // Check if database data is being loaded (excluding asana tasks)
  const isLoadingDatabaseData = loading.db_data;
  
  // Show loading spinner only when actively loading database data
  if (isLoadingDatabaseData) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <LoadingSpinner size="large" />
          <p className="text-gray-600">Loading application data...</p>
        </div>
      </div>
    );
  }
  
  return <>{children}</>;
};